module.exports = "<h1 class=\"specifications-title\">Specifications</h1>\r\n<hr/>\r\n<markdown class=\"markdown-body\" path=\"{{technology.specification}}\"></markdown>\r\n"


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/app/components/technology/technology-specification/technology-specification.component.html
// module id = ./Frontend/src/app/components/technology/technology-specification/technology-specification.component.html
// module chunks = main